import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import { IEquipe } from "../../../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import {
    AtualizarEquipeController,
    GetEquipeController,
} from "../../../../../Controllers/HelpDesk/Equipes/EquipesControllers";

import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import { GetIntegracoesWhatsappController } from "../../../../../Controllers/Geral/Integracao/IntegracoesController";
import { IIntegracoesDados } from "../../../../../Interfaces/Geral/Integracoes/IntegracoesInterface";
import UnForm from "../../../../../Components/Form";
import { ListarFormulariosController } from "../../../../../Controllers/Geral/Formularios/FormulariosControllers";

interface IGeralProps {
    ID_FILA: number;
    updateList: () => void;
}

interface IGeralEditForm extends IEquipe {
    ID_GERENTE: number;
}

export function Geral(props: IGeralProps) {
    const { formState } = useForm<IGeralEditForm>();

    const [equipe, setEquipe] = useState<IEquipe>();
    const [LstIngracoesDados, setLstIngracoesDados] =
        useState<Array<IIntegracoesDados>>();
    const [Numero, setNumero] = useState<String>();

    useEffect(() => {
        updateEquipe(props.ID_FILA);
    }, [props.ID_FILA]);

    function updateEquipe(ID_EQUIPE: number) {
        GetEquipeController(ID_EQUIPE).then((res) => {
            setEquipe(res);
            setNumero(res.NR_TELEFONE);
        });

        GetIntegracoesWhatsappController().then((res) => {
            setLstIngracoesDados(res);
        });
    }

    function handleEditNameForm(formData: IGeralEditForm) {
        if (equipe) {
            AtualizarEquipeController({
                ...equipe,
                DS_EQUIPE_HELP_DESK: formData.DS_EQUIPE_HELP_DESK,
                NR_TELEFONE: formData.NR_TELEFONE,
                FL_ATIVO: equipe.FL_ATIVO,
                FL_DISTRIBUICAO: equipe?.FL_DISTRIBUICAO,
                ID_EQUIPE_HELP_DESK: equipe.ID_EQUIPE_HELP_DESK,
                ID_FORMULARIO: Number(formData.ID_FORMULARIO) ?? 0,
            }).then(() => {
                props.updateList();
            });
        }
    }

    return (
        <div className="d-flex flex-column flex-lg-row flex-lg-row-fluid">
            {equipe ? (
                <>
                    <div className="d-flex flex-column justify-content-center align-items-center col-12 col-lg-6">
                        <UnForm
                            className="mb-3"
                            id="group-name-edit-form"
                            handleSubmit={handleEditNameForm}
                        >
                            <div className="w-100">
                                <>
                                    <UnForm.Input
                                        className={`form-control p-2 placeholder-dark-75 ${
                                            formState.errors
                                                .DS_EQUIPE_HELP_DESK &&
                                            "is-invalid"
                                        }`}
                                        type="text"
                                        defaultValue={
                                            equipe.DS_EQUIPE_HELP_DESK
                                        }
                                        name="DS_EQUIPE_HELP_DESK"
                                        registerOptions={{
                                            required: "Insira o nome da equipe",
                                        }}
                                    />
                                    <div className="invalid-feedback">
                                        {formState.errors.DS_EQUIPE_HELP_DESK
                                            ? formState.errors
                                                  .DS_EQUIPE_HELP_DESK.message
                                            : ""}
                                    </div>
                                </>

                                <>
                                    <UnForm.Select
                                        name="NR_TELEFONE"
                                        value={
                                            Numero?.toString() ||
                                            equipe.NR_TELEFONE
                                        }
                                        className={`form-control p-1 placeholder-dark-75 mt-3 ${
                                            formState.errors.NR_TELEFONE &&
                                            "is-invalid"
                                        }`}
                                        registerOptions={{
                                            required: "Selecione um número",
                                        }}
                                        onChange={(e) => {
                                            setNumero(e.target.value);
                                        }}
                                    >
                                        {LstIngracoesDados?.length ? (
                                            LstIngracoesDados.map(
                                                (integracao) => {
                                                    return (
                                                        <option
                                                            key={
                                                                integracao.ID_TIPO_INTEGRACAO_ATRIBUTO
                                                            }
                                                            value={
                                                                integracao.DS_VALOR
                                                            }
                                                        >
                                                            {
                                                                integracao.DS_INTEGRACAO
                                                            }
                                                        </option>
                                                    );
                                                }
                                            )
                                        ) : (
                                            <option></option>
                                        )}
                                    </UnForm.Select>
                                    <span className="label abel-pill label-inline label-dark mt-2">
                                        {Numero}
                                    </span>
                                    <div className="invalid-feedback">
                                        {formState.errors.NR_TELEFONE
                                            ? formState.errors.NR_TELEFONE
                                                  .message
                                            : ""}
                                    </div>
                                </>
                                <div className="d-flex justify-content-center pt-2">
                                    <UnForm.LazySelect
                                        controller={ListarFormulariosController}
                                        getDS={(e) => e.DS_FORMULARIO}
                                        getKeyValue={(e) => e.ID_FORMULARIO}
                                        className="form-control p-2 placeholder-dark-75"
                                        name="ID_FORMULARIO"
                                        label="Formulário"
                                        defaultValue={equipe.ID_FORMULARIO}
                                    >
                                        <option value={undefined}></option>
                                    </UnForm.LazySelect>
                                </div>
                                <div className="d-flex justify-content-center pt-8">
                                    <button className="btn btn-outline-success font-weight-bold w-100">
                                        <FontAwesomeIcon
                                            icon={faEdit}
                                            size="lg"
                                            className="mr-2"
                                        />
                                        Atualizar Dados
                                    </button>
                                </div>
                            </div>
                        </UnForm>
                    </div>
                    <div className="d-flex flex-column justify-content-between align-items-center col-12 col-lg-6">
                        <div className="row d-flex align-items-start justify-content-start w-100">
                            <div className="col-12 col-md-6 d-flex flex-column align-itens-center justify-content-center">
                                <span
                                    className="switch switch-outline switch-lg switch-icon switch-success d-flex justify-content-center"
                                    data-toggle="tooltip"
                                >
                                    <label>
                                        <input
                                            id="fL_ATIVO_STATUS"
                                            name="fL_ATIVO"
                                            checked={equipe?.FL_ATIVO || false}
                                            type="checkbox"
                                            onChange={() => {
                                                AtualizarEquipeController({
                                                    ...equipe,
                                                    FL_ATIVO: !equipe?.FL_ATIVO,
                                                }).then(() => {
                                                    updateEquipe(props.ID_FILA);
                                                    props.updateList();
                                                });
                                            }}
                                        />
                                        <span></span>
                                    </label>
                                </span>
                                <div className="text-center font-weight-bold">
                                    Equipe Ativa
                                </div>
                            </div>
                            <div className="col-12 col-md-6 d-flex flex-column align-itens-center justify-content-center">
                                <span
                                    className="switch switch-outline switch-lg switch-icon switch-warning d-flex justify-content-center"
                                    data-toggle="tooltip"
                                >
                                    <label>
                                        <input
                                            id="FL_DISTRIBUICAOO_STATUS"
                                            name="FL_DISTRIBUICAO"
                                            checked={
                                                equipe?.FL_DISTRIBUICAO || false
                                            }
                                            type="checkbox"
                                            onChange={() => {
                                                AtualizarEquipeController({
                                                    ...equipe,
                                                    FL_DISTRIBUICAO:
                                                        !equipe?.FL_DISTRIBUICAO,
                                                }).then(() => {
                                                    updateEquipe(props.ID_FILA);
                                                    props.updateList();
                                                });
                                            }}
                                        />
                                        <span></span>
                                    </label>
                                </span>
                                <div className="text-center font-weight-bold">
                                    Equipe de Distribuição
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <SpinnerComponent />
            )}
        </div>
    );
}
